var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSelfAssessmentScore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    d: "M2.25 2.25v13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10.75h9v2.75a.75.75 0 0 1-.75.75H2.25v-3.5z",
    stroke: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.25H15a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-.75.75H2.25v-3.5zM2.25 3.75h10.5a.75.75 0 0 1 .75.75v2.75H2.25v-3.5z",
    stroke: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfAssessmentScore);
export default __webpack_public_path__ + "static/media/self-assessment-score.910ae98bb674552d0d68aabd06014942.svg";
export { ForwardRef as ReactComponent };